module.exports = __webpack_public_path__ + "static/img/partner_VIII.380834d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_VIII.png
// module id = POId
// module chunks = 9